import React from 'react';
import { Gift, Clock, Heart, Moon } from 'lucide-react';
import { Section, SectionTitle } from './Shared';
export function Bonuses() {
  return <div className="bg-cream-dark border-y border-beige-muted/50" data-id="element-58">
      <Section data-id="element-59">
        <SectionTitle data-id="element-60">
          Hoy además te llevás estos bonos que hacen que funcione más rápido
        </SectionTitle>

        <div className="grid md:grid-cols-3 gap-8 mt-12" data-id="element-61">
          {/* Bonus 1 */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-beige-muted/50 relative overflow-hidden group hover:shadow-md transition-shadow" data-id="element-62">
            <div className="absolute top-0 left-0 w-full h-2 bg-sage" data-id="element-63"></div>
            <div className="bg-sage-light/30 w-14 h-14 rounded-xl flex items-center justify-center mb-6" data-id="element-64">
              <Clock className="w-7 h-7 text-sage-dark" data-id="element-65" />
            </div>
            <h3 className="font-bold text-charcoal text-xl mb-3" data-id="element-66">
              🎁 BONO 1: RUTINAS PODEROSAS
            </h3>
            <p className="text-charcoal-light mb-2" data-id="element-67">
              Vas a saber exactamente qué hacer cada día para que tu bebé
              empiece a dormir mejor.
            </p>
            <p className="text-charcoal-light/70 text-sm italic mb-4" data-id="element-68">
              (Sin improvisar ni probar cosas al azar)
            </p>
            <span className="inline-block bg-cta/10 text-cta text-sm font-bold px-3 py-1 rounded-full" data-id="element-69">
              Incluido GRATIS hoy
            </span>
          </div>

          {/* Bonus 2 */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-beige-muted/50 relative overflow-hidden group hover:shadow-md transition-shadow" data-id="element-70">
            <div className="absolute top-0 left-0 w-full h-2 bg-gold" data-id="element-71"></div>
            <div className="bg-gold-light/50 w-14 h-14 rounded-xl flex items-center justify-center mb-6" data-id="element-72">
              <Heart className="w-7 h-7 text-gold-hover" data-id="element-73" />
            </div>
            <h3 className="font-bold text-charcoal text-xl mb-3" data-id="element-74">
              🎁 BONO 2: MASAJE SHANTALA
            </h3>
            <p className="text-charcoal-light mb-4" data-id="element-75">
              Una técnica simple que ayuda a relajar a tu bebé y mejorar el
              sueño desde los primeros días.
            </p>
            <span className="inline-block bg-cta/10 text-cta text-sm font-bold px-3 py-1 rounded-full" data-id="element-76">
              Incluido GRATIS hoy
            </span>
          </div>

          {/* Bonus 3 */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-beige-muted/50 relative overflow-hidden group hover:shadow-md transition-shadow" data-id="element-77">
            <div className="absolute top-0 left-0 w-full h-2 bg-sage" data-id="element-78"></div>
            <div className="bg-sage-light/30 w-14 h-14 rounded-xl flex items-center justify-center mb-6" data-id="element-79">
              <Moon className="w-7 h-7 text-sage-dark" data-id="element-80" />
            </div>
            <h3 className="font-bold text-charcoal text-xl mb-3" data-id="element-81">
              🎁 BONO 3: REGRESIONES DEL SUEÑO
            </h3>
            <p className="text-charcoal-light mb-4" data-id="element-82">
              Vas a entender por qué vuelve a despertarse y qué hacer para no
              volver al punto cero.
            </p>
            <span className="inline-block bg-cta/10 text-cta text-sm font-bold px-3 py-1 rounded-full" data-id="element-83">
              Incluido GRATIS hoy
            </span>
          </div>
        </div>

        {/* Bottom text */}
        <div className="text-center mt-12 space-y-3" data-id="element-84">
          <p className="text-charcoal font-medium text-lg" data-id="element-85">
            💡 Estos bonos son lo que hace que el método funcione incluso si ya
            probaste de todo.
          </p>
          <p className="text-cta font-bold text-lg" data-id="element-86">
            👉 Todo incluido GRATIS hoy
          </p>
        </div>
      </Section>
    </div>;
}